<template>
  <div></div>
</template>

<script>
export default {
  name: 'StripePayment',
  props: [
    'locale'
  ],
  computed: {
    getPayInfo: {
      get () {
        return this.$store.getters['payment/getPaymentInfo']
      },
      set (data) {
        this.payInfo = this._.cloneDeep(data)
      }
    }
  },
  mounted () {
    this.isSeparate = this.$route.name === 'separatePayment'
    if (this.getPayInfo) {
      this.payInfo = this._.cloneDeep(this.getPayInfo)
      setTimeout(() => {
        window.location.href = this.payInfo.url
      }, 100)
    }
  },
  data () {
    return {
      payInfo: null,
      isSeparate: false
    }
  }
}
</script>
